var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-one"}},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"img",attrs:{"src":_vm.data.banner}})])])}
var staticRenderFns = []

export { render, staticRenderFns }